import { useCallback, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { ReactComponent as MoreIcon } from '../../../assets/image/more-vert.svg';
import { ReactComponent as Question } from '../../../assets/image/question.svg';
import * as Styled from './styles';

export type ButtonOptionsType = {
  value: string;
  action: () => void;
  isTooltip?: boolean;
  tooltipText?: string;
};

export type MoreButtonProps = {
  options: ButtonOptionsType[];
};

const MoreButton = (props: MoreButtonProps) => {
  const intl = useIntl();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownEl = useRef<HTMLUListElement>(null);

  const handleClickOutSide = useCallback(
    (e) => {
      if (
        showDropdown &&
        e.target.closest('.dropdown') !== dropdownEl.current
      ) {
        setShowDropdown(false);
      }
    },
    [showDropdown, setShowDropdown, dropdownEl]
  );

  useEffect(() => {
    document.addEventListener('click', handleClickOutSide);
    return () => {
      document.removeEventListener('click', handleClickOutSide);
    };
  }, [handleClickOutSide]);

  return (
    <>
    <Styled.Button onClick={() => setShowDropdown(!showDropdown)} hasTooltip={props.options.some((option) => option.isTooltip)} >
      <MoreIcon />
      {showDropdown && (
        <ul className='dropdown' ref={dropdownEl}>
          {props.options.map((option, index) => (
            <li key={`${option.value}_${index}`} onClick={option.action}>
              {option.isTooltip ? (
                <Styled.Tooltip>
                  <span>{intl.formatMessage({ id: option.value })}</span>
                  <Styled.Img className="tooltip">
                    <Question />
                    <span className="tooltiptext">{intl.formatMessage({ id: option.tooltipText })}</span>
                  </Styled.Img>
                </Styled.Tooltip>
              ) : (
                intl.formatMessage({ id: option.value })
              )}
            </li>
          ))}
        </ul>
      )}
    </Styled.Button>
    </>
  );
};

export default MoreButton;
